import { subscribe } from '../errors/sagas';
import { notificationError } from '../errors/notificationTypes';

const pre = 'STATICDATAISDA/';

export const SAVE_CONFIGURATION_FAILED = `${pre}SAVE_CONFIGURATION_FAILED`;
export const LOAD_CONFIGURATION_FAILED = `${pre}LOAD_CONFIGURATION_FAILED`;

subscribe(SAVE_CONFIGURATION_FAILED, 'There was an error saving the configuration', notificationError);
subscribe(LOAD_CONFIGURATION_FAILED, 'There was an error loading your configuration', notificationError);

export const saveConfigurationFailed = error => ({
    type: SAVE_CONFIGURATION_FAILED,
    error
});

export const loadConfigurationFailed = error => ({
    type: LOAD_CONFIGURATION_FAILED,
    error
});
